export function formatThousands(value: number): string {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0');
}

export function formatThousandsInt(value: number): string {
    const integerPart = Math.floor(value);

    return integerPart.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0');
}
